import { Image, Loader2 } from "lucide-react";

// GitHub Octicon "markdown" (MIT).
function MarkdownMark() {
	return (
		<svg viewBox="0 0 16 16" aria-hidden className="size-4 fill-current">
			<path d="M14.85 3c.63 0 1.15.52 1.14 1.15v7.7c0 .63-.51 1.15-1.15 1.15H1.15C.52 13 0 12.48 0 11.84V4.15C0 3.52.52 3 1.15 3ZM9 11V5H7L5.5 7 4 5H2v6h2V8l1.5 1.92L7 8v3Zm2.99.5L14.5 8H13V5h-2v3H9.5Z" />
		</svg>
	);
}

export function MarkdownFooter({
	uploading,
	onAttach,
}: {
	uploading: boolean;
	onAttach: () => void;
}) {
	return (
		<div className="flex items-center gap-3 px-2 pb-2 text-xs text-muted-foreground">
			<span className="flex items-center gap-1.5">
				<MarkdownMark />
				Markdown is supported
			</span>
			<span aria-hidden className="h-4 w-px bg-border" />
			{uploading ? (
				<span className="flex items-center gap-1.5">
					<Loader2 className="size-3.5 animate-spin" />
					Uploading files...
				</span>
			) : (
				<button
					type="button"
					onClick={onAttach}
					className="flex items-center gap-1.5 rounded hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
				>
					<Image className="size-3.5" />
					Paste, drop, or click to add files
				</button>
			)}
		</div>
	);
}
